/**
 * Consultas en vivo al SNT (ANMAT) vía backend → riga.
 * GET /api/snt/gln/:gln — datos del agente registrado para un GLN.
 * Solo lectura, nada se persiste.
 */

import { apiFetch } from '@/api/http';

export interface GlnSntAgente {
  gln: string;
  razonSocial: string | null;
  cuit: string | null;
  direccion: string | null;
  numero: string | null;
  codigoPostal: string | null;
  localidad: string | null;
  provincia: string | null;
  telefono: string | null;
  email: string | null;
  /** "Tipo agente SNT" (ej. "LABORATORIO"). */
  tipoAgente: string | null;
  idTipoAgente: string | null;
}

/**
 * Consulta un GLN contra el SNT. Devuelve el agente o `null` si el SNT no lo
 * encuentra (no es error). Lanza si el SNT falla.
 */
export async function consultarGlnSnt(gln: string): Promise<GlnSntAgente | null> {
  const data = await apiFetch<{ gln: GlnSntAgente | null }>(
    `/snt/gln/${encodeURIComponent(gln)}`,
    { auth: true },
  );
  return data.gln ?? null;
}
